'use strict';

const _ = {
    find: require('lodash/find'),
    forEach: require('lodash/forEach'),
    isEmpty: require('lodash/isEmpty'),
    map: require('lodash/map'),
    some: require('lodash/some'),
};
const SafeStringify = require('json-stringify-safe');

const Globals = require('../globals');

const ActivityValidation = require('@muzzylane/nova/lib/client_tools').ActivityValidation;
const ShortCourseConstants = require('./ShortCourseConstants');

const ShortCourseUtil = {

    // if ignoreNonAssessmentCb is true, only assessment stars are counted
    getNodeGateStatus: function(doc, node_id, user_id, ignoreNonAssessmentCb=false) {
        //console.log(`getNodeGateStatus for node_id ${node_id}`);
        if (!user_id) {
            user_id = doc.user.id;
        }
        // scan our subskill states to determine remediating and lowest subskill gate
        let min_ss_gate;
        let remediating = false;
        let remediation_level = 0;
        _.forEach(doc.subskills,(ss)=>{
            let nr = ss.node_relations[node_id];
            if (nr) {
                let ss_state = nr.subskill_states[user_id];
                if (ss_state) {
                    if (ss_state.remediating) {
                        remediating = true;
                        if (remediation_level) {
                            remediation_level = Math.min(remediation_level,ss_state.remediation_level);
                        }
                        else {
                            remediation_level = ss_state.remediation_level;
                        }
                    }
                    if (typeof min_ss_gate === 'undefined') {
                        min_ss_gate = ss_state.gate;
                    }
                    else {
                        min_ss_gate = Math.min(min_ss_gate,ss_state.gate);
                    }
                }
            }
        })
        
        let gate, min_gate, max_gate;
        let stars = 0;
        let total_stars = 0;
        let star_gate_map = {
            // [gate]: {
            //     [subskill_hash]: {
            //          star_counted: bool (true if already counted toward stars)
            //          total_counted: bool (true if already counted toward total_star)
            //     }
            // }
        };
        
        // scan thru all the content blocks associated with this node and determine what the lowest and highest gates are
        // also count the number of stars
        _.forEach(doc.content_blocks,(cb)=>{
            const isBot = (cb.type === Globals.short_course.content_block_type.CHATBOT);
            const nr = cb.node_relations[node_id]; // relationData: {activity_type}
            if (nr) {
                let atype = _.find(doc.activity_types,{id:nr.activity_type});
                if (atype) {
                    const isAssessment = (atype.credit_type === Globals.short_course.node_content_credit_type.ASSESSMENT);
                    const isTutorial = (atype.credit_type === Globals.short_course.node_content_credit_type.TUTORIAL); // non-scoring
                    if (isTutorial) {
                        return; // don't count this for anything
                    }
                    const countStars = isAssessment || !ignoreNonAssessmentCb;
                    if (countStars) {
                        let cb_name = cb.hash; // fallback
                        if (isBot) {
                            cb_name = cb.display_title;
                        }
                        else {
                            if (cb.activity && cb.activity.meta_data) {
                                if (cb.activity.meta_data.display_name) {
                                    cb_name = cb.activity.meta_data.display_name;
                                }
                                else if (cb.activity.meta_data.title) {
                                    cb_name = cb.activity.meta_data.title;
                                }
                                
                            }
                        }
                        let gate_map = star_gate_map[atype.gate] || {};
                        _.forEach(doc.subskills,(ss)=>{
                            if (!ss.hash) {
                                console.log("Error: missing ss.hash",ss); // FIXME: remove debug spam
                            }
                            if (!cb.subskill_relations[ss.hash]) {
                                //console.log(`${cb_name}: node ${node_id} gate ${atype.gate} subskill ${ss.display_name} ${ss.hash} has no relation.`);
                                return; // don't count subskill since it's unrelated to the activity content block 
                            }
                            let star_count_flags = gate_map[ss.hash] || {};
                            let ss_nr = ss.node_relations[node_id];
                            if (ss_nr) {
                                let ss_state = ss_nr.subskill_states[user_id];
                                if (ss_state) {
                                    if (ss_state.gate > atype.gate) {
                                        if (!isAssessment || !star_count_flags.star_counted) {
                                            stars++;
                                            //console.log(`${cb_name}: counting star for node ${node_id} gate ${atype.gate} subskill ${ss.display_name} ${ss.hash}`);
                                            if (isAssessment) {
                                                star_count_flags.star_counted = true;
                                            }
                                        }
                                        //else {
                                        //    console.log(`${cb_name}: already counted star for node ${node_id} gate ${atype.gate} subskill ${ss.display_name} ${ss.hash}`);
                                        //}
                                    }
                                    if (!isAssessment || !star_count_flags.total_counted) {
                                        total_stars++;
                                        // console.log(`${cb_name}: counting star total for node ${node_id} gate ${atype.gate} subskill ${ss.display_name} ${ss.hash}`);
                                        if (isAssessment) {
                                            star_count_flags.total_counted = true;
                                        }
                                    }
                                    //else {
                                    //    console.log(`${cb_name}: already counted star total for node ${node_id} gate ${atype.gate} subskill ${ss.display_name} ${ss.hash}`);
                                    //}
                                }
                            }
                            gate_map[ss.hash] = star_count_flags;
                        });
                        star_gate_map[atype.gate] = gate_map;
                    }
                    if (typeof min_ss_gate != 'undefined') {
                        if (atype.gate === min_ss_gate) {
                            gate = atype.gate; // exact match
                        }
                        else if (atype.gate > min_ss_gate) {
                            if (typeof gate === 'undefined') {
                                gate = atype.gate; // first possible match
                            }
                            else if (gate > atype.gate) {
                                gate = atype.gate; // better than our previous match
                            }
                        }
                    }
                    if (isAssessment || remediating) {
                        if (typeof min_gate === 'undefined') {
                            min_gate = atype.gate;
                            max_gate = atype.gate + 1; // gate is one past the last gate ( when finished with the node )
                        }
                        else {
                            if (min_gate > atype.gate) {
                                min_gate = atype.gate;
                            }
                            if (max_gate < atype.gate + 1) {
                                max_gate = atype.gate + 1;
                            }
                        }
                    }
                } // if has an activity type object
            } // if node related
        }); // for content blocks

        if (typeof min_gate === 'undefined') {
            min_gate = 1;
        }
        
        if (typeof max_gate === 'undefined') {
            max_gate = 4;
        }

        if (typeof gate === 'undefined') {
            if (typeof min_ss_gate !== 'undefined') {
                gate = min_ss_gate; // possibly finished
            }
            else {
                gate = min_gate;
            }
        }


        return {gate, min_gate, max_gate, remediating, remediation_level, stars, total_stars};
    }, // getNodeGateStatus
    
    isNodeComplete: function(doc,node_id,userId) {
        const node = _.find(doc.nodes,{node_id});
        if (!node) {
            return;
        }
        let { gate, min_gate, max_gate, remediating } = ShortCourseUtil.getNodeGateStatus(doc,node_id,userId);
        // console.log(`"isNodeComplete for ${node_id}": { gate: ${gate}, min_gate: ${min_gate}, max_gate: ${max_gate}, remediating: ${remediating} }`);
        return (gate >= max_gate) && !remediating;
    }, //isNodeComplete

    // recursive.  
    // returns true if all the prerequisites are satisfied or false if any are not
    getArePrerequisitesSatisfied: function(doc, node_id,visited,userId) {
        const node = _.find(doc.nodes,{node_id});
        if (!node) {
            console.log(`getArePrerequisitesSatisfied given invalid node_id ${node_id}`); // FIXME: remove debug spam
        }
        if (!visited) {
            visited = {};
            visited[node_id] = null; // we will set this again later. Mark it for now so we don't cycle
        }
        else if (_.isEmpty(visited)) {
            // caller passed in an empty visited map so they get the individual results 
            visited[node_id] = null; // we will set this again later. Mark it for now so we don't cycle
        }
        else {
            // this is a recursion (and a prerequisite of the initial node)
            let v = visited[node_id];
            if (typeof v !== 'undefined') {
                return visited[node_id]; // we already got an answer for this node.  This also prevents infinite loops if there is a cycle in the graph
            }
            if (!node || !ShortCourseUtil.isNodeComplete(doc,node_id,userId)) {
                visited[node_id] = false;
                return false;
            }
        }
        if (!node) {
            visited[node_id] = false;
            return false;
        }
        let satisfied = true;
        _.forEach(node.prereq_node_ids,(pre_id)=>{
            let pre_sat = ShortCourseUtil.getArePrerequisitesSatisfied(doc,pre_id,visited,userId);
            if (pre_sat === false) {
                satisfied = false;
                return false; // exit forEach
            }
            // else it could be null (if there is a cycle and we found the starting node)
            // or (more likely) it's true and we're satisfied (so far)
        });
        visited[node_id] = satisfied;
        return satisfied;
    }, // getArePrerequisitesSatisfied

    getContentBlock: function(doc,hash) {
        return hash && _.find(doc.content_blocks,{hash});
    }, //getContentBlock

    getArbitraryIncompleteNode: function(doc, latest_attempt_node_id, optional_cb_hash, userId) {
        if (latest_attempt_node_id) {
            if (!ShortCourseUtil.isNodeComplete(doc,latest_attempt_node_id,userId)) {
                if (ShortCourseUtil.getArePrerequisitesSatisfied(doc,latest_attempt_node_id,undefined,userId)) {
                    return latest_attempt_node_id;
                }
            }
        }
        let cb = ShortCourseUtil.getContentBlock(doc,optional_cb_hash);

        let node_id = null;
        _.forEach(doc.nodes,(node)=>{
            if (cb) {
                let cb_ok = false;
                const nr = cb.node_relations[node.node_id]; // relationData: {activity_type}
                let activity_type = nr ? nr.activity_type : cb.activity_type;
                let activityTypeObj = _.find(doc.activity_types,{id:activity_type});
                if (activityTypeObj) {
                    let remedial = (activityTypeObj.credit_type === Globals.short_course.node_content_credit_type.PRACTICE);
                    let tutorial = (activityTypeObj.credit_type === Globals.short_course.node_content_credit_type.TUTORIAL);
                    if (remedial || tutorial || nr) {
                        cb_ok = true;
                    }
                }
                if (!cb_ok) {
                    return; // skip this node
                }
            }
            if (!ShortCourseUtil.isNodeComplete(doc,node.node_id,userId)) {
                if (ShortCourseUtil.getArePrerequisitesSatisfied(doc,node.node_id,undefined,userId)) {
                    node_id = node.node_id;
                    return false;
                }
            }
        });
        return node_id;
    }, // getArbitraryIncompleteNode
    
    getCourseOverallResult: function(doc, userId, ignoreNonAssessmentCb=false) {
        let progress = 0; // 0 to 100
        let score = 0; // 0 to 100
        let complete = false;
        if (!doc.nodes.length) {
            return { complete, score, progress,
                error: "no nodes"
            }
        }
        
        let stars = 0;
        let total_stars = 0;
        complete = true;
        _.forEach(doc.nodes,(node)=>{
            if (!ShortCourseUtil.isNodeComplete(doc,node.node_id, userId)) {
                complete = false;
            }
            let { gate, min_gate, max_gate, remediating, stars:node_stars, total_stars:node_total_stars } = ShortCourseUtil.getNodeGateStatus(doc, node.node_id, userId, ignoreNonAssessmentCb);
            stars += node_stars;
            total_stars += node_total_stars;
        });
        progress = total_stars ? Math.round(stars * 100 / total_stars) : 0; // progress per redmine #6049
        score = progress; // TBD
        return { complete, score, progress, stars, total_stars };
    },
    
    validateShortCourse: function(shortCourseStoreState) {
        const doc = shortCourseStoreState.shortCourse && shortCourseStoreState.shortCourse.doc;
        const actValidation = new ActivityValidation( (shortCourseStoreState && shortCourseStoreState.hash) || "short_course", (doc && doc.version) || "0.0.0");
        
        const REMEDIAL_ACTIVITY_TYPES = ['REMEDIAL_1','REMEDIAL_2'];
        const ASSESSMENT_ACTIVITY_TYPES = ['KNOWLEDGE_CHECK','PRE_TEST','FINAL'];
        
        if (!doc) {
            actValidation.addError('no data');
            return actValidation.toJSON();
        }
        
        if (!doc.nodes || !doc.nodes.length) {
            actValidation.addError('no nodes');
        }

        if (!doc.content_blocks || !doc.content_blocks.length) {
            actValidation.addError('no content blocks');
        }

        let remedial_counts = {};
        let top_level_remedials = 0;
        let assessment_counts_per_node = {};
        let tutorial_counts_per_node = {};
        _.forEach(doc.nodes,(node)=>{
            let node_id = node.node_id;
            if (!assessment_counts_per_node[node_id]) {
                assessment_counts_per_node[node_id] = {};
                _.forEach(Globals.short_course.ASSESSMENT_ACTIVITY_TYPES,(t)=>{
                    assessment_counts_per_node[node_id][t] = 0;
                });
            }
            tutorial_counts_per_node[node_id] = 0;
        });
        
        let subskills_per_node = {};
        _.forEach(doc.content_blocks, (cb)=>{
            let cb_is_remedial = false;
            let remedial_index = Globals.short_course.REMEDIAL_ACTIVITY_TYPES.indexOf(cb.activity_type);
            if (remedial_index >= 0) {
                cb_is_remedial = true;
                top_level_remedials ++;
                remedial_counts[cb.activity_type] = (remedial_counts[cb.activity_type] || 0) + 1; 
            }
            else if (cb.activity_type) {
                actValidation.addError(`content block ${cb.nova_activity_id} cannot be ${cb.activity_type} at the course (top) level (remedial only)`);
            }
            _.forEach(cb.node_relations,(nr,node_id)=>{
                const node = _.find(doc.nodes,{node_id});
                if (!node) {
                    actValidation.addError(`content block ${cb.nova_activity_id} has connection to missing node ${node_id}`);
                }
                else {
                    let assessment_index = Globals.short_course.ASSESSMENT_ACTIVITY_TYPES.indexOf(nr.activity_type);
                    let remedial_index = Globals.short_course.REMEDIAL_ACTIVITY_TYPES.indexOf(nr.activity_type);
                    let tutorial_index = Globals.short_course.TUTORIAL_ACTIVITY_TYPES.indexOf(nr.activity_type);
                    if (cb_is_remedial && (assessment_index >= 0)) {
                        actValidation.addError(`content block ${cb.nova_activity_id} cannot be both remedial and assessment for ${node_id}`);
                    }
                    if (assessment_index >= 0) {
                        assessment_counts_per_node[node_id][nr.activity_type] = (assessment_counts_per_node[node_id] || 0) + 1; 
                    }
                    else {
                        if (remedial_index >= 0) {
                            remedial_counts[nr.activity_type] = (remedial_counts[nr.activity_type] || 0) + 1; 
                        }
                        else if (tutorial_index >= 0) {
                            tutorial_counts_per_node[node_id] = (tutorial_counts_per_node[node_id] || 0) + 1;
                        }
                        else {
                            actValidation.addError(`node ${node_id} content block ${cb.nova_activity_id} has invalid activity_type ${nr.activity_type}`);
                        }
                    }

                    if (!subskills_per_node[node_id]) {
                        subskills_per_node[node_id] = [];
                    }
                }
            });
        });
        
        _.forEach(doc.subskills,(ss)=>{
            _.forEach(ss.node_relations,(dummy,node_id)=>{
                if (node_id) {
                    if (!subskills_per_node[node_id]) {
                        subskills_per_node[node_id] = [];
                    }
                    subskills_per_node[node_id].push({
                        hash: ss.hash,
                        display_name: ss.display_name
                    });
                }
            })
        });
        
        
        _.forEach(Globals.short_course.REMEDIAL_ACTIVITY_TYPES,(rt)=>{
            if (!remedial_counts[rt]) {
                let niceName = Globals.short_course.content_block_activity_types[rt];
                actValidation.addWarning(`no ${niceName} activities`);
            }
        });
        
        let capstone_node_count = 0;
        let skill_node_count = 0;
        let prereq_count_map = {};
        let circle_detected = false;
        
        function getPrereqTreeCount(node) {
            let x_count = prereq_count_map[node.node_id];
            if (x_count === 'counting') {
                circle_detected = true;
                console.log(`circle detected counting prerequisites of node ${node.node_id} "${node.name}"`);
                return 0;
            }
            else if (x_count) {
                return x_count;
            }
            let count = 0;
            prereq_count_map[node.node_id] = 'counting';
            _.forEach(node.prereq_node_ids,(pre_id)=>{
                let preNode = _.find(doc.nodes,{node_id:pre_id});
                if (preNode) {
                    count = (1 + getPrereqTreeCount(preNode));
                }
                else {
                    actValidation.addError(`node ${node.node_id} "${node.name}" has invalid prereq ${pre_id}`);
                }
            });
            prereq_count_map[node.node_id] = count;
            return count;
        }
        
        let nodes_with_no_prerequisites = 0;
        _.forEach(doc.nodes,(node)=>{
            let count = getPrereqTreeCount(node);
            // console.log(`node ${node.node_id} "${node.name}" has ${count} deep prerequisites`);
            if (!count) {
                nodes_with_no_prerequisites++;
            }
        });
        
        if (nodes_with_no_prerequisites !== 1) {
            actValidation.addError("node tree is broken");
        }
        
        if (circle_detected) {
            actValidation.addError("node tree is cyclic");
        }

        if (doc.badge_parameters && doc.badge_parameters.issueBadge) {
            if (!doc.badge_parameters.badge_template_hash) {
                actValidation.addError("issueBadge is checked but the badge is not specified");
            }
        }
        
        _.forEach(doc.nodes,(node)=>{
            const node_counts = assessment_counts_per_node[node.node_id];
            const node_subskills = subskills_per_node[node.node_id] || [];
            const navLoc = {type: ShortCourseConstants.NAV_TYPES.Node, id: node.node_id};
            const node_tutorial_count = tutorial_counts_per_node[node.node_id];
            if (node_tutorial_count > 1) {
                actValidation.addWarning(`node has multiple tutorial activities (only one will be used)`,navLoc);
            }
            else if (!node_tutorial_count) {
                actValidation.addMessage(`node does not have a tutorial activity`,navLoc);
            }
            
            if (node.capstone) {
                capstone_node_count++;
                if (!node_counts) {
                    actValidation.addError(`capstone has no assessment activity`,navLoc);
                }
                _.forEach(node_counts,(n,t)=>{
                    if (t === 'FINAL') {
                        if (!n) {
                            actValidation.addError(`capstone does not have a final assessment`,navLoc);
                        }
                        else if (n > 0) {
                            actValidation.addError(`capstone has ${n} final assessment activities (expecting only 1)`,navLoc);
                        }
                    }
                    else if (n) {
                        actValidation.addError(`capstone should only have a final assessment.  Instead it has ${n} ${t} activities`,navLoc);
                    }
                });
                
                if (!node_subskills.length) {
                    actValidation.addError(`capstone doesn't use any subskills`,navLoc);
                }
            }
            else {
                _.forEach(node_counts,(n,t)=>{
                    if (!n || (n>1)) {
                        actValidation.addError(`skill node ${node.node_id} "${node.name}" has ${n} ${t} activities. Expecting exactly 1`,navLoc);
                    }
                });				
                skill_node_count++;
                // see if there are the same number of subskills for each content block associated with this node
                if (node_subskills.length) {
                    let subskill_mismatch = false;
                    
                    let ref_cb;
                    let ref_cb_subskill_hashes = [];
                    _.forEach(doc.content_blocks,(cb)=>{
                        let nr = cb.node_relations[node.node_id];
                        if (nr && Globals.short_course.ASSESSMENT_ACTIVITY_TYPES.indexOf(nr.activity_type) >= 0) {
                            let mismatches = 0;
                            let matches = 0;
                            _.forEach(cb.subskill_relations,(ss,hash)=>{
                                if (_.find(node_subskills,{hash})) {
                                    if (!ref_cb) {
                                        ref_cb = cb;
                                    }
                                    if (cb.hash === ref_cb.hash) {
                                        ref_cb_subskill_hashes.push(hash);
                                    }
                                    else {
                                        if (ref_cb_subskill_hashes.indexOf(hash) < 0) {
                                            mismatches++;
                                        }
                                        else {
                                            matches++;
                                        }
                                    }
                                }
                                //else {
                                //	let lookup_ss = _.find(doc.subskills,{hash});
                                //	actValidation.addMessage(`skill node ${node.node_id} does not use subskill ${lookup_ss ? lookup_ss.display_name : hash} from activity ${cb.nova_activity_id}`);
                                //}
                            });
                            if (!ref_cb) {
                                actValidation.addWarning(`no assessment content blocks for node ${node.node_id}`,navLoc);
                            }
                            else if (ref_cb.hash != cb.hash) {
                                if (mismatches || (matches !== ref_cb_subskill_hashes.length) ) {
                                    subskill_mismatch = true;
                                    return false; // early exit
                                    // actValidation.addError(`skill node ${node.node_id} activity ${ref_cb.nova_activity_id} does not use the same subskills as ${cb.nova_activity_id}`);
                                }
                            }
                        }
                    });
                    
                    if (subskill_mismatch) {
                        actValidation.addError(`Skill node ${node.node_id} "${node.name}" activities do not all use the same subskills`,navLoc);
                    }
                }
                else {
                    actValidation.addError(`skill node ${node.node_id} does not use any subskills`,navLoc);
                }
            }
        });
        if (capstone_node_count !== 1) {
            actValidation.addWarning(capstone_node_count ? `${capstone_node_count} capstone nodes` : 'no capstone node');
        }
        
        if (!top_level_remedials) {
            actValidation.addMessage('no top level remedial activities');
        }
        
        
        return actValidation.toJSON();
    }, // validateShortCourse

    getRemediationLevel: function(params) {
        let { gate, score, doc } = params;
        // const mastery_score = doc.mastery_score || 75;
        const tutorial_score_a2 = doc.tutorial_score_a2 || 45;
        const tutorial_score_a3 = doc.tutorial_score_a3 || 35;
        if ( gate <= 1 ) {
            return 1; // always use REMEDIAL_1 for A1 (beginner/gate 1 assessment) 
        }
        if (gate === 2) {
            return (score < tutorial_score_a2) ? 1 : 2;
        }
        return (score < tutorial_score_a3) ? 1 : 2;
    },

    getUpdatedSubskills: function(params) {
        let { 
            prior_subskill_arr, 
            activityTypeObject, 
            contentAttemptId, 
            attemptNumber,
            subskillRelations, // cb.subskill_relations
            score, keyedScResults, // scores from nova activity
            scoresBySubskillHash, // scores by hash
            courseInstance, 
            logger 
        } = params;
        const masteryScore = courseInstance.mastery_score; 
        const NO_RESULT = {subskills: null, attempt_subskill_impacts: null }; 


        // determine current gate
        let current_gate, advance_gate, found_remediating;
        _.forEach(prior_subskill_arr,(ss_stat)=>{
            if (typeof current_gate === 'undefined') {
                current_gate = ss_stat.gate;
            }
            else {
                current_gate = Math.min(current_gate,ss_stat.gate);
            }
            if (ss_stat.remediating) {
                found_remediating = true;
                advance_gate = ss_stat.gate + 1; // if remediating, we haven't advanced the subskill
            }
        });
        // set a default (in case prior_subskill_arr is empty) - redmine #7177
        if (typeof current_gate === 'undefined') {
            current_gate = 1; 
        }
        
        // Note: if credit_type is Globals.short_course.node_content_credit_type.TUTORIAL this function should not have been called!
        const assessing = (activityTypeObject.credit_type === Globals.short_course.node_content_credit_type.ASSESSMENT);
        const remediating = (activityTypeObject.credit_type === Globals.short_course.node_content_credit_type.PRACTICE);
        
        if (!assessing && !remediating) {
            logger.warn(`Unable to getUpdatedSubskills for activity type ${JSON.stringify(activityTypeObject)}`);
            return NO_RESULT;
        }
        if (found_remediating !== remediating) {
            logger.warn("warning - skill status vs activity type mismatch",{
                remediating, found_remediating,
                contentAttemptId,
                skill_stats: JSON.stringify(prior_subskill_arr)
            });
        }
        if (assessing) {
            advance_gate = activityTypeObject.gate + 1;
        }
        if (typeof advance_gate === 'undefined') {
            logger.error("unable to determine gate advance level",SafeStringify(params));
            advance_gate = 2; // Maybe there were no subskills?  
        }

        const mastered_subskills = [];
        const failed_subskills = [];
        
        subskillRelations.forEach((subskillRelation) => {
            let subskill_score;
            if (scoresBySubskillHash) {
                subskill_score = scoresBySubskillHash[subskillRelation.subskill_hash];
            }
            else if (subskillRelation.cb_score_type === Globals.short_course.content_block_score_req_type.OVERALL) {
                subskill_score = score;
            }
            else if (subskillRelation.cb_score_type === Globals.short_course.content_block_score_req_type.OBJECTIVE) {
                if (typeof keyedScResults[subskillRelation.objective_name] === 'number') {
                    subskill_score = keyedScResults[subskillRelation.objective_name];
                }
                else {
                    logger.warn(`Missing keyedScResults for ${subskillRelation.objective_name}`)
                    return;
                }
            }
            else {
                logger.warn(`Unsupported content block score type: ${subskillRelation.cb_score_type}`)
                return;
            }
            if (subskill_score >= masteryScore) {
                mastered_subskills.push({
                    id: subskillRelation.mzl_course_version_subskill_id,
                    score: subskill_score,
                    hash: subskillRelation.subskill_hash,
                });
            }
            else {
                failed_subskills.push({
                    id: subskillRelation.mzl_course_version_subskill_id,
                    score: subskill_score,
                    hash: subskillRelation.subskill_hash,
                });
            }
        });
        
        //console.log(`mastered_subskills: ${JSON.stringify(mastered_subskills)}`);
        //console.log(`failed_subskills: ${JSON.stringify(failed_subskills)}`);
        //console.log(`activityTypeObject: ${JSON.stringify(activityTypeObject)}`);
        
        if (mastered_subskills.length || failed_subskills.length) {
            let subskills = [];
            let attempt_subskill_impacts = []; // this will include all subskills involved in the attempt, including the no impact skills
            
            // determine what gate we can advance to if we pass a subskill
            let next_gate;
            if (assessing) {
                next_gate = advance_gate;
            }
            else {
                let any_advance_to_r2 = _.some(prior_subskill_arr,(prior_stat)=>{
                    if ((prior_stat.remediation_level === 1) && (prior_stat.gate > 1)) { // advance from R1 to R2 (redmine #6081)
                        return true;
                    }
                    return false;
                });
                next_gate = current_gate;
                if ((current_gate < 3) && !any_advance_to_r2) {
                    next_gate = advance_gate; // redmine #5989 remedial can advance us to the next gate but not past the final gate
                }
            }
            
            mastered_subskills.forEach((entry) => {
                let prior_stat = _.find(prior_subskill_arr,{subskill_id: entry.id});
                let gate_impact = 0;
                let remedial_impact;
                if (prior_stat && (prior_stat.remediation_level === 1) && (prior_stat.gate > 1)) { // advance from R1 to R2 (redmine #6081)
                    subskills.push({
                        subskill_id: entry.id, 
                        remediation_level: 2,
                        score: null,
                        attempts: 0, 
                    });
                    remedial_impact = 1;
                }
                else {
                    // advance to the next gate (or just clear the remediation flag if we are on a3)
                    subskills.push({
                        subskill_id: entry.id,
                        score: null,
                        remediating: false,
                        remediation_level: 0,
                        attempts: 0, 
                        gate: next_gate,
                    })
                    gate_impact = (next_gate - current_gate);
                    remedial_impact = gate_impact ? 0 : 1;
                }
//                if (prior_stat) {
//                    console.log(`entry.hash ${entry.hash} vs prior_stat.hash ${prior_stat.hash}`);
//                    if (prior_stat.hash === entry.hash) {
//                        console.log("same (FIX GOOD)")
//                    }
//                    else {
//                        console.log("different (FIX BAD)")
//                    }
//                }
                
                attempt_subskill_impacts.push({
                    subskill_hash: entry.hash,
                    score: entry.score,
                    gate_impact,
                    remedial_impact,
                });
            });

            let any_r2 = _.some(prior_subskill_arr,{remediation_level:2});
            failed_subskills.forEach((entry) => {
                let prior_stat = _.find(prior_subskill_arr,{subskill_id: entry.id});
                let remediation_level = prior_stat && prior_stat.remediation_level; // avoid changing remediation levels when we fail
                if (!remediation_level) {
                    if (any_r2) {
                        remediation_level = 2; // avoid mixing remediation levels if we fail an additional skill
                    }
                    else {
                        remediation_level = ShortCourseUtil.getRemediationLevel({gate:current_gate, score: entry.score, doc: courseInstance});
                    }
                }
                subskills.push({
                    subskill_id: entry.id,
                    score: entry.score,
                    remediating: true,
                    remediation_level,
                    attempts: attemptNumber, 
                });
                let remedial_impact = 0;
                if (remediation_level && prior_stat && prior_stat.remediation_level) {
                    remedial_impact = (prior_stat.remediation_level > remediation_level) ? -1 : 0; // did we get worse?
                }
                attempt_subskill_impacts.push({
                    subskill_hash: entry.hash,
                    score: entry.score,
                    gate_impact: 0,
                    remedial_impact,
                });
            }); // for failed subskills
                
            //console.log(`\n adjustments after failing a(n) ${assessing ? "assessment" : "remedial"} activity:`);
            //console.log("prior_subskills:    ",JSON.stringify(prior_subskill_arr));
            //console.log("adjusted subskills: ",JSON.stringify(subskills));

            return { subskills, attempt_subskill_impacts };
        } // if any subskills were involved in the activity

        // no subskills at all
        return NO_RESULT;
    }, // getUpdatedSubskills

};

module.exports = ShortCourseUtil;